import { render, staticRenderFns } from "./PersonTypePie.vue?vue&type=template&id=06e2246f&scoped=true&"
import script from "./PersonTypePie.vue?vue&type=script&lang=js&"
export * from "./PersonTypePie.vue?vue&type=script&lang=js&"
import style0 from "./PersonTypePie.vue?vue&type=style&index=0&id=06e2246f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2246f",
  null
  
)

export default component.exports